import React from 'react';
import withCustomPreview from '~/components/FileUploaded/withCustomPreview';
import PreviewAsImg from '~/components/FileUploaded/picture-preview/PreviewAsImg';
import { formLabel } from '~/utils/helpers';
import { useField } from 'formik';
import { FormFeedback } from '~/components/FormControl';
import isEmpty from 'lodash/isEmpty';
import { useWithCustomPreviewContext } from '~/components/FileUploaded/withCustomPreview';

const CLAPreviewPictureWithHOC = () => {
    const { pictureUrl, inputEl, width, height, minWidth, maxWidth, heightWrapper, wrapperClass, pictureName } =
        useWithCustomPreviewContext();
    const [, meta] = useField(pictureName);

    return (
        <>
            <PreviewAsImg
                pictureUrl={pictureUrl}
                inputEl={inputEl}
                width={width}
                height={height}
                minWidth={minWidth}
                maxWidth={maxWidth}
                heightWrapper={heightWrapper}
                wrapperClass={wrapperClass}
                id={pictureName}
            />
            <figcaption>{formLabel(pictureName)}</figcaption>
            <FormFeedback
                isInvalid={!isEmpty(meta.error) && meta.touched}
                errorMessage={meta.error}
                className={'text-center'}
            />
        </>
    );
};

export default withCustomPreview(CLAPreviewPictureWithHOC);
